import React from 'react';
import { UserProvider } from '@/contexts/UserContext';

interface UserWrapperProps {
  children: React.ReactNode;
}

export const UserWrapper: React.FC<UserWrapperProps> = ({ children }) => {
  return <UserProvider>{children}</UserProvider>;
};
